import gql from 'graphql-tag'

export const PAPER_CHECK = gql`
  mutation PaperCheck($request: PaperCheckInput!) {
    paperCheck(request: $request) {
      paperId
      sentences {
        id
        position {
          length
          offset
        }
      }
    }
  }
`

export const SENTENCE_CHECK = gql`
  mutation SentenceCheck($request: SentenceCheckInput!) {
    sentenceCheck(request: $request) {
      isSuccess
    }
  }
`
